export default __webpack_public_path__ + "static/media/37f5f75a6e190ac707ebc9c124266fe31636390730755.d8779018.webp";